import React, { ReactNode } from 'react';
import { cn } from '../../utils';
import {
  ANIMATION_DURATION,
  SIDEBAR_DIMENSIONS,
} from '../layout/app-sidebar/constants';

interface UILogoProps {
  logo: ReactNode;
  href?: string;
  isCollapsed: boolean;
  className?: string;
}

export function UILogo({ logo, href, isCollapsed, className }: UILogoProps) {
  const logoContainerStyle = {
    width: isCollapsed ? SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_WIDTH : 'auto',
    marginLeft: isCollapsed
      ? SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_MARGIN_LEFT
      : 'auto',
    marginRight: isCollapsed ? '0' : 'auto',
    transition: `width ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), margin-left ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), margin-right ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
  };

  const logoWrapper = (
    <div
      className="tw-flex tw-items-center tw-flex-shrink-0"
      style={{
        width: isCollapsed ? SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_WIDTH : 'auto',
        minWidth: isCollapsed
          ? SIDEBAR_DIMENSIONS.LOGO_COLLAPSED_WIDTH
          : 'auto',
        transition: `width ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1), min-width ${ANIMATION_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1)`,
      }}
    >
      {typeof logo === 'string' ? (
        <img
          src={logo}
          alt="Logo"
          style={{
            height: '30px',
            objectFit: 'contain',
          }}
        />
      ) : React.isValidElement(logo) && logo.type === 'img' ? (
        React.cloneElement(
          logo as React.ReactElement<{
            className?: string;
            style?: React.CSSProperties;
          }>,
          {
            className: (logo as React.ReactElement).props.className,
            style: {
              height: '30px',
              objectFit: 'contain',
              ...(logo as React.ReactElement).props.style,
            },
          }
        )
      ) : (
        logo
      )}
    </div>
  );

  if (href) {
    return (
      <a
        id="sidebar-logo"
        href={href}
        className={cn(
          'tw-flex-shrink-0 tw-flex tw-items-center tw-overflow-hidden tw-no-underline',
          className
        )}
        style={logoContainerStyle}
      >
        {logoWrapper}
      </a>
    );
  }

  return (
    <div
      id="sidebar-logo"
      className={cn(
        'tw-flex-shrink-0 tw-flex tw-items-center tw-overflow-hidden',
        className
      )}
      style={logoContainerStyle}
    >
      {logoWrapper}
    </div>
  );
}
